<div class="jw-modal" *ngIf="this.isOpen">
    <div class="jw-modal-body w-full md:w-1/2 h-fit">
        <ng-content></ng-content>
    </div>
</div>